// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aircraft-registration-cancellation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aircraft-registration-cancellation/aircraft-registration-cancellation.js';

mount([g0]);
